import { FC } from 'react';

interface MetricComparisonCaptionProps {
  caption?: string;
}

/**
 * The "value in previous period" caption shared by metric headers and tiles.
 */
const MetricComparisonCaption: FC<MetricComparisonCaptionProps> = ({
  caption,
}) => {
  if (!caption) {
    return null;
  }

  return (
    <p
      data-cy="analytics-metric-comparison-caption"
      className="tw-font-light tw-text-sm tw-text-grayscale-100"
    >
      {caption}
    </p>
  );
};

export default MetricComparisonCaption;
